import React, { useState,useEffect } from 'react';
import CustomTable from '../../../customComponents/CustomTable';
import {TABLE_HEADERS,keyMapping } from '../../../../constants/LeadALlocationList';

import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../routes/routes';
import TotalCounts from '../TotalCounts';
import searchIcon from './../../../../Assets/icons/searchicon.svg';
import ListPreSalesFilters from '../../Admin/OnBoardManagement/Onboard/ListPreSalesFilter/ListPreSalesFilter';
import { IoMdClose } from "react-icons/io";
import ListLogisticsFilters from '../../Logistics/LogisticsFilter';

const LeadAllocationList = () => {
  const [activeSection, setActiveSection] = useState('Customer');
  const [searchTerm, setSearchTerm] = useState('');
  const [leadAllocation,setLeadAllocation] = useState([])
  const [ filterFormData, setFilterFormData ] = useState({})
  const [validationErrors, setValidationErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();
  const [ productdd, setProductdd ] = useState([])
  const [ makedd, setMakedd ] = useState([])

  const token = localStorage.getItem("authToken");
  const [filters, setFilters] = useState({
    product: '',
    make: '',
    model: '',
    fromDate: '',
    toDate: ''
  });

  const [ make, setMake ] = useState([])
  const [ model, setModel ] = useState([])
  const [ product, setProduct ] = useState([])

//   const handleSectionChange = (section) => {
//     setActiveSection(section);
//   };
useEffect(() => {
  fetchUnassignedList();
}, []);
const handlePageChange = (newPage) => {
  setCurrentPage(newPage);
  fetchUnassignedList(newPage);
};

const fetchUnassignedFilterList = async (filterData) => {
  try {
    const response = await axiosInstance.post('/getunassignlist/list', {
      // Adjust the API endpoint and parameters according to your API
      startDate: filterData.fromDate,
        endDate: filterData.toDate,
      make_id: filterData.make,
        model_id: filterData.model,
        product_id: filterData.product
    }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });

    const formattedData = response.data.data.data.map((item, index) => ({
      ...item,
      "Sr No.": index + 1  
    }));

    setLeadAllocation(formattedData);
    //toastSuccess("Product Data fetched successfully!")
  } catch (error) {
    console.error('Error fetching lead priorities:', error);
  }
};


const fetchUnassignedList = async (  page = 0, pageSize = 10) => {

  const allfilteredData=filters;

  try {
    const response = await axiosInstance.post('/getunassignlist/list', {
      // Adjust the API endpoint and parameters according to your API
      orderBy: 'lead_id desc',
      assigntype:"leadexecutive",
      page,
      pageSize,
      startDate: allfilteredData?.fromDate?allfilteredData?.fromDate:null ,
      endDate: allfilteredData?.toDate?allfilteredData?.toDate:null ,
     make_id: allfilteredData?.make? allfilteredData?.make : null,
     model_id: allfilteredData?.model? allfilteredData?.model : null,
     product_id: allfilteredData?.product? allfilteredData?.product : null,
      searchText: searchTerm || ''
    }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });

    const formattedData = response.data.data.data.map((item, index) => ({
      ...item,
      "Sr No.": index + 1  
    }));

    const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

    setLeadAllocation(formattedData);
   // toastSuccess("Product Data fetched successfully!");
    setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
  } catch (error) {
    console.error('Error fetching lead priorities:', error);
  }
};

const handleEditButton = (rowData) => {
 // alert("edit")
  console.log("rowdata>>>>", rowData);
  navigate(`${ROUTES_NAVIGATION.ADDNEWLEAD}`, { state: { data: rowData } });
  // console.log("rowdata", rowData)
}

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      fetchUnassignedList({ searchText: searchTerm });
    }
  };

  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  useEffect(() => {
    if (searchTerm === '') {
      fetchUnassignedList({ searchText: '' });
    }
  }, [searchTerm]);

  useEffect(() => {
    // fetchProductDD()
    fetchProductOptions()
  },[])

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post('/product/list', {
        orderBy: 'product_id desc',
        page: 0,
        pageSize: 100, // Adjust as needed
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const options = response.data.data.data.map(product => ({
        label: product.product_name,
        value: product.product_id,
      }));

      setProduct(options);
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  useEffect(() => {
    console.log(filterFormData, "FORMDATA")
    // if(filterFormData.make_id){
      const productId = filterFormData.product_id;
      if (productId){
        fetchMakeDD(productId)
        setMake([])
      }
    // }
  },[filterFormData.product_id])

  // useEffect(() => {
  //   console.log("product>>>",product);
  //       console.log(productdd.value, "PRODUCTDD")
  //     const productId = productdd.value
  //     console.log(productdd, "PRODUCTDD")
  //          fetchMakeDD(productId);
  //          setMake([]) 
  //    }, [productdd]);

   
     useEffect(() => {
      //  console.log("make>>>>>>", make)
      console.log(filterFormData, "FORMDATATA")
   
      //  console.log(makedd.value, "MAKEDD")
      //  console.log(productdd.value, "PRODUCTDD")
       const makeId = filterFormData.make_id;
       const productId = filterFormData.product_id;

       if ( productId && makeId ){
         fetchModelDD(makeId, productId)
     
         setModel([])
       }
   
     },[filterFormData.make_id, filterFormData.product_id])
   
     const fetchMakeDD = async (productId) => {
       try{
         const business_partner_id = 1;
         const response = await axiosInstance.post("/make/ddlmake",{
           business_partner_id ,
           product_id: productId,
         },{
           headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
           },
         })
   
         const fetchedData = response.data.data.data
         const makedata = fetchedData.map(dropdown =>({
           value: dropdown.ID,
           label:dropdown.NAME
         }))
         setMake(makedata)
   
       }catch(error){
         console.log(error, "error")
       }
     }
   
     const fetchModelDD = async (makeId, productId) => {
       try{
   
         const business_partner_id = 1;
   
         const response = await axiosInstance.post("/model/ddlmodel",{
           business_partner_id ,
           product_id: productId,
           make_id:makeId,
         },{
           headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
           },
         })
   
         const fetchedData = response.data.data.data
         const modeldata = fetchedData.map(dropdown =>({
           value: dropdown.ID,
           label:dropdown.NAME
         }))
         setModel(modeldata)
   
       }catch(error){
         console.log(error, "error")
       }
     }

//   const renderTableData = () => {
//     let filteredData = [];
//     switch (activeSection) {
//       case 'Customer':
//         filteredData = TABLE_DATA.customers.filter(customer =>
//           Object.values(customer).some(value =>
//             String(value).toLowerCase().includes(searchTerm.toLowerCase())
//           )
//         );
//         break;
//       case 'Agent':
//         filteredData = TABLE_DATA.agents.filter(agent =>
//           Object.values(agent).some(value =>
//             String(value).toLowerCase().includes(searchTerm.toLowerCase())
//           )
//         );
//         break;
//       case 'Company':
//         filteredData = TABLE_DATA.companies.filter(company =>
//           Object.values(company).some(value =>
//             String(value).toLowerCase().includes(searchTerm.toLowerCase())
//           )
//         );
//         break;
//       default:
//         filteredData = [];
//     }
//     return filteredData;
//   };

//   const renderTableHeaders = () => {
//     switch (activeSection) {
//       case 'Customer':
//         return TABLE_HEADERS.customers;
//       case 'Agent':
//         return TABLE_HEADERS.agents;
//       case 'Company':
//         return TABLE_HEADERS.companies;
//       default:
//         return [];
//     }
//   };

//   const renderKeyMapping = () => {
//     switch (activeSection) {
//       case 'Customer':
//         return keyMapping.customers;
//       case 'Agent':
//         return keyMapping.agents;
//       case 'Company':
//         return keyMapping.companies;
//       default:
//         return [];
//     }
//   };

//   const renderAddButtonLabel = () => {
//     switch (activeSection) {
//       case 'Customer':
//         return 'Add New Customer';
//       case 'Agent':
//         return 'Add New Agent';
//       case 'Company':
//         return 'Add New Company';
//       default:
//         return 'Add New';
//     }
//   };

//   const handleAddButtonClick = () => {
//     switch (activeSection) {
//       case 'Customer':
//         navigate('/admin/manage-onboard/onboard/create-customer');
//         break;
//       case 'Agent':
//         navigate('/admin/manage-onboard/onboard/create-agent');
//         break;
//       case 'Company':
//         navigate('/admin/manage-onboard/onboard/create-company');
//         break;
//       default:
//         break;
//     }
//   };

  const formatDataForDownload = (data, headers, keyMapping) => {
    const csvHeaders = headers.map(header => keyMapping[header]);
    const csvRows = data.map(item => {
      return headers.map(header => {
        const key = keyMapping[header];
        return item[key];
      }).join(',');
    });
    const csvContent = [
      csvHeaders.join(','),
      ...csvRows
    ].join('\n');
    return csvContent;
  };

  const handleDownloadClick = () => {
    const csvContent = formatDataForDownload(leadAllocation, TABLE_HEADERS, keyMapping);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${activeSection}_data.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const clearFilter = () => {
    setFilterFormData({})
    setFilters({});
    fetchUnassignedList(0, 10);
  };
  
  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      make: filterFormData.make_id || null,     
      model: filterFormData.model_id || null,    
      product: filterFormData.product_id || null 
    });
  
    fetchUnassignedList(0 , 10)
    // fetchFollowUpRequireeList(0, 10);
  
  };

  useEffect(() => {
    fetchUnassignedList();
  }, [filters]);
  
  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),  
      required: true,
      gridClass: "col-lg-2",
    },
    {
        name: "endDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-2",
    },
    {
      name: "product_id",
      label: "Product",
      placeholder:"Select City",
      type: "dropdown",
      options: product,
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "make_id",
      label: "Make",
      placeholder:"Select City",
      type: "dropdown",
      options: make,
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "model_id",
      label: "Model",
      placeholder:"Select City",
      type: "dropdown",
      options: model,
      required: true,
      gridClass: "col-lg-2",
    }
  ]

  const handleViewButton = (rowdata) => {
    console.log("rowdata>>>",rowdata);
    
    navigate(ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS,{state:{data:rowdata}})
  }


  return (
    <div>
      <div className='OnboardManagamentContainer row'>
         <TotalCounts title={"Lead Allocation"}  subtitle={"Home/Presales"}/>
       
      </div>
      <div className='tableWrapper'>
      <div className='listsearchContainerr'>
            <h5>Lead Allocation List</h5>
            <div className="searchinput-wrapper">
              <input
                type='text'
                className='searchinput'
                placeholder='Search..'
                value={searchTerm}
                onChange={handleSearchInputChange}
                onKeyDown={handleSearchKeyPress}
              />
             {searchTerm ? (
                <IoMdClose size={22} className="searchinput-close-icon" onClick={clearSearchAndFetch} />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )}
            </div>
          </div>
      <div className='admin-list-containerr'>
          
          <div style={{display:"flex"}} className='filterWrapper'>
            <p style={{paddingRight:"8px", marginTop:"75px", marginLeft:"14px"}} >Filter By</p>
         <ListLogisticsFilters
      formConfig={PhysicalStockTakingInputs} 
      formData={filterFormData}
      setFormData={setFilterFormData}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      handleSearch={handleSearch}
      handleClear={clearFilter}
      // onSubmit={handleFormSubmit} 
      />
      </div>
        
          
        </div>

        <CustomTable data={leadAllocation} headers={TABLE_HEADERS} keyMapping={keyMapping} isAllocation={true}  itemsPerPage={10}
         currentPage={currentPage}
         totalPages={totalPages}
         onPageChange={handlePageChange}
         onEdit={handleEditButton} 
         handleViewButton={handleViewButton}
         totalRecords={totalRecords} 
         fetchUnassignedFilterList={fetchUnassignedFilterList}
         fetchUnassignedList={fetchUnassignedList}
         isasignLead={true}
         />
      </div>
    </div>
  );
};

export default LeadAllocationList;
